export function WalkOffStorytellerIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 10v20c0 6 4 10 10 10s10-4 10-10V10" />
      <path d="M14 10c0 6 10 10 10 10s10-4 10-10" />
      <line x1="24" y1="28" x2="24" y2="36" />
      <path d="M20 32h8" />
    </svg>
  );
}
